import React from 'react';
import { Text as RNText, TextStyle, StyleSheet, StyleProp } from 'react-native';
import { Theme } from '../../utils/theme';

interface TextProps {
  children: React.ReactNode;
  variant?: 'heading1' | 'heading2' | 'heading3' | 'heading4' | 'h1' | 'h2' | 'h3' | 'body1' | 'body2' | 'caption' | 'button';
  color?: 'primary' | 'secondary' | 'tertiary' | 'disabled' | 'inverse' | 'success' | 'error' | 'warning';
  align?: 'left' | 'center' | 'right';
  style?: StyleProp<TextStyle>;
  numberOfLines?: number;
  onPress?: () => void;
}

export default function Text({
  children,
  variant = 'body1',
  color = 'primary',
  align = 'left',
  style,
  numberOfLines,
  onPress,
}: TextProps) {
  const textStyle = [
    styles[variant],
    styles[`${color}Color`],
    align !== 'left' && { textAlign: align },
    style,
  ];

  return (
    <RNText
      style={textStyle}
      numberOfLines={numberOfLines}
      onPress={onPress}
    >
      {children}
    </RNText>
  );
}

const styles = StyleSheet.create({
  // Typography variants
  heading1: {
    ...Theme.typography.heading1,
  },
  heading2: {
    ...Theme.typography.heading2,
  },
  heading3: {
    ...Theme.typography.heading3,
  },
  heading4: {
    ...Theme.typography.heading4,
  },
  // Aliases for h1, h2, h3 (matching web style guide)
  h1: {
    ...Theme.typography.heading1,
    color: Theme.colors.textPrimary,
  },
  h2: {
    ...Theme.typography.heading2,
    color: Theme.colors.textPrimary,
  },
  h3: {
    ...Theme.typography.heading3,
    color: Theme.colors.textPrimary,
  },
  body1: {
    ...Theme.typography.body1,
  },
  body2: {
    ...Theme.typography.body2,
  },
  caption: {
    ...Theme.typography.caption,
  },
  button: {
    ...Theme.typography.button,
  },
  
  // Color variants
  primaryColor: {
    color: Theme.colors.textPrimary,
  },
  secondaryColor: {
    color: Theme.colors.textSecondary,
  },
  tertiaryColor: {
    color: Theme.colors.textTertiary,
  },
  disabledColor: {
    color: Theme.colors.textDisabled,
  },
  inverseColor: {
    color: Theme.colors.textInverse,
  },
  successColor: {
    color: Theme.colors.success,
  },
  errorColor: {
    color: Theme.colors.error,
  },
  warningColor: {
    color: Theme.colors.warning,
  },
}); 